import React, { useState } from 'react';
import classNames from 'classnames';
import Tinymce from "fantastic/components/common/Tinymce";

const Editor = ({ value, onChange, className, children }) => {

  const classes = classNames("s-copywriter-editor", {
    "ink": !children,
    "s-copywriter-editor_empty": !!children
  });

  if (children) return <div className={classes}>{children}</div>;

  return (
    <div className={classes}>
      <div className="mail">
        <Tinymce
          html={value}
          onChange={onChange}
          promptActive={false}
        />
      </div>
    </div>
  );
};

export default Editor;
